
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    blurValue: {
      type: Boolean,
      default: false,
    },
    numberFormat: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    getWholeNumbers() {
      return this.value.split(this.getSplitCharacter())[0]
    },
    getDecimalNumbers() {
      return this.value.split(this.getSplitCharacter())[1]
    },
  },
  methods: {
    getSplitCharacter() {
      switch (this.$i18n.locale) {
        case 'en':
          return '.'
        case 'nl':
          return ','
        default:
          return ','
      }
    },
  },
}
